import client, { getErrorMessage } from '@shared/utils/client-rest'
import type { IInsightAlert } from '@shared-types/insights'

interface CountResponse {
	count?: string | number
}

class Notifications {
	insight_data: IInsightAlert[] = []
	count = 0
	finished = false
	per_page = 20

	is_loading_insights = false
	insights_error_message = ''

	is_loading_count = false
	count_error_message = ''

	isInsightsError = () => this.insights_error_message.trim().length > 0
	isCountError = () => this.count_error_message.trim().length > 0

	fetchInsights = async (params: {
		customer_id: string | number
		url_params?: Record<string, unknown>
		is_loadmore?: boolean
		is_realtime?: boolean
	}): Promise<void> => {
		const { customer_id, url_params = {}, is_loadmore = false, is_realtime = false } = params

		if (is_loadmore && this.finished) {
			return
		}

		this.is_loading_insights = true

		return await client(`/api/v1/pages/insights/integrations/${is_realtime ? 'realtime/' : ''}notifications`, {
			params: {
				customer_id,
				limit: this.per_page,
				offset: is_loadmore ? this.insight_data.length : 0,
				...(url_params || {}),
			},
		})
			.then((res: IInsightAlert[]) => {
				this.insights_error_message = ''

				if (is_loadmore) {
					this.insight_data = [...this.insight_data, ...res]
				} else {
					this.insight_data = res
				}

				if (res?.length < this.per_page) {
					this.finished = true
				}
			})
			.catch((err) => {
				this.insights_error_message = getErrorMessage(err, 'An unknown error occurred while loading the notifications')
			})
			.finally(() => {
				this.is_loading_insights = false
			})
	}

	getCount = async (params: { customer_id: string; is_realtime?: boolean }): Promise<void> => {
		const { customer_id, is_realtime = false } = params
		this.is_loading_count = true

		return await client(
			`/api/v1/pages/insights/integrations/${is_realtime ? 'realtime/' : ''}notifications/new-count`,
			{
				params: {
					customer_id,
				},
			},
		)
			.then((res: CountResponse) => {
				this.count = Number.parseInt(String(res?.count), 10)
			})
			.catch((err) => {
				this.count = 0
				this.count_error_message = getErrorMessage(
					err,
					'An unknown error occurred while loading the notifications count',
				)
			})
			.finally(() => {
				this.is_loading_count = false
			})
	}

	setAlertsAsRead = (insight_alert_ids: string[], onSuccess?: () => void) => {
		let call_onsuccess = false

		this.insight_data = this.insight_data.map((record) => {
			if (insight_alert_ids.includes(record.insight_alert_id)) {
				record.is_new = false
				call_onsuccess = true
			}

			return record
		})

		if (call_onsuccess) {
			onSuccess?.()
		}
	}

	// update = async (id: string | number, data: Record<string, unknown>): Promise<void> => {
	// 	return await client(`/api/v1/pages/notifications/${id}`, {
	// 		method: 'PUT',
	// 		body: {
	// 			...data,
	// 		},
	// 	})
	// 		.then(() => {
	// 			this.updateItem(id, data)
	// 			m.redraw()
	// 		})
	// 		.catch((err: any) => console.error(err?.message === '[object Object]' ? JSON.stringify(err) : err))
	// }

	// bulkUpdate = async (data: Record<string, unknown>): Promise<void> => {
	// 	return await client(`/api/v1/pages/notifications`, {
	// 		method: 'PATCH',
	// 		body: {
	// 			...data,
	// 		},
	// 	})
	// 		.then(() => {
	// 			this.data?.map((i) => this.updateItem(i.id, data))
	// 			m.redraw()
	// 		})
	// 		.catch((err: any) => console.error(err?.message === '[object Object]' ? JSON.stringify(err) : err))
	// }

	// updateItem = async (id: string | number, data: Record<string, unknown>): Promise<NotificationItem | undefined> => {
	// 	const index = this.data.findIndex((item) => item.id === id)

	// 	return (this.data[index] = { ...this.data[index], ...data })
	// }

	// pauseNotification = async (data: Record<string, unknown>, is_de_active: boolean): Promise<unknown> => {
	// 	let body: Record<string, unknown> = { ...data }
	// 	if (is_de_active) {
	// 		const current_route = router.currentRoute()

	// 		const dst = current_route?.query?.dst
	// 		if (!dst) return console.warn('Network Fetch Metrics: Insufficient ATT Params')

	// 		const date_range_short_term = decodeDateRange(dst)

	// 		const { end_date } = date_range_short_term

	// 		body = {
	// 			...body,
	// 			period_end: new Date(end_date).toISOString(),
	// 		}
	// 	}

	// 	return await client(`/api/v1/pages/alert-settings`, {
	// 		method: 'POST',
	// 		body,
	// 	}).then((res: unknown) => {
	// 		m.redraw()
	// 		return res
	// 	})
	// }

	// unPauseNotification = async (id: string | number): Promise<unknown> => {
	// 	return await client(`/api/v1/pages/alert-settings/${id}`, {
	// 		method: 'DELETE',
	// 	}).then((res: unknown) => {
	// 		m.redraw()
	// 		return res
	// 	})
	// }

	// updatePauseNotification = async (
	// 	id: string | number,
	// 	data: Record<string, unknown>,
	// 	is_de_active: boolean,
	// ): Promise<unknown> => {
	// 	let body: Record<string, unknown> = { ...data }
	// 	if (is_de_active) {
	// 		const current_route = router.currentRoute()

	// 		const dst = current_route?.query?.dst
	// 		if (!dst) return console.warn('Network Fetch Metrics: Insufficient ATT Params')

	// 		const date_range_short_term = decodeDateRange(dst)

	// 		const { end_date } = date_range_short_term

	// 		body = {
	// 			...body,
	// 			period_end: new Date(end_date).toISOString(),
	// 		}
	// 	}

	// 	return await client(`/api/v1/pages/alert-settings/${id}`, {
	// 		method: 'PUT',
	// 		body,
	// 	}).then((res: unknown) => {
	// 		m.redraw()
	// 		return res
	// 	})
	// }

	// resetAlert = async (body: Record<string, unknown>): Promise<void> => {
	// 	const current_route = router.currentRoute()

	// 	const dst = current_route?.query?.dst
	// 	if (!dst) return console.warn('Network Fetch Metrics: Insufficient ATT Params')

	// 	const date_range_short_term = decodeDateRange(dst)

	// 	const { end_date } = date_range_short_term

	// 	client('/api/v1/pages/alert-reference-period', {
	// 		method: 'POST',
	// 		body: {
	// 			...body,
	// 			period_end: end_date,
	// 		},
	// 	}).then((res: unknown) => {
	// 		m.redraw()
	// 		return res
	// 	})
	// }

	// close = (): void => {
	// 	this.data.length = 0
	// 	this.finished = false
	// }

	reset = () => {
		this.insight_data = []
		this.finished = false
	}
}

export default new Notifications()
